<script setup lang="ts">
import { ref } from "vue";
import ReservationExpiry from "@/domains/home/services/configurations/views/reservations/ReservationExpiry.vue";
import ResponsesTemplate from "@/domains/home/services/configurations/views/reservations/ResponsesTemplate.vue";

const currentRoute = ref<string>('expiry')

const select = (route: string) => {
  currentRoute.value = route
}
</script>

<template>
  <div class="flex flex-col">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-2">
        <p
            @click="select('expiry')"
            :class="[(currentRoute === 'expiry') ? 'menu-pill-active' : 'menu-pill']">
          Expiry & Notifications
        </p>
        <p
            @click="select('responses')"
            :class="[(currentRoute === 'responses') ? 'menu-pill-active' : 'menu-pill']">
          Response Templates
        </p>
      </div>
      <div class="col-span-10">
        <div class="grid grid-cols-12 gap-4">
          <div class="col-span-12">
            <ReservationExpiry v-if="currentRoute === 'expiry'"/>
            <ResponsesTemplate v-if="currentRoute === 'responses'"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
